import { Component, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

const CUSTOM_VALUE_ACCESSOR: any = {
  provide : NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TariffButtonsComponent),
  multi: true,
};

@Component({
  selector: 'app-tariff-buttons',
  providers: [CUSTOM_VALUE_ACCESSOR],
  templateUrl: './tariff-buttons.component.html',
  styleUrls: ['./tariff-buttons.component.css']
})
export class TariffButtonsComponent  {
  private _tarif: string;
  private onChange = (_: any) => { };
  private onTouched = () => { };

  disabled: boolean = false;
  
  isActive(value: string) {
    return value === this._tarif;
  }

  setTarif(value: string) {
    this._tarif = value;
    this.onChange(this._tarif);
    this.onTouched();
  }

  writeValue(obj: any) {
    this._tarif = obj;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
